import React from 'react';


const PERIODS = ['Day', 'Week', 'Month', 'Quarter', 'Year'];
const COMPARISONS = ['YoY', 'MoM', 'WoW', 'Custom'];

export default function TimePeriodSelector({ period, setPeriod, comparison, setComparison }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
      <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
        {PERIODS?.map((p) => (
          <button
            key={p}
            onClick={() => setPeriod(p)}
            className={`px-3 py-1.5 rounded-md font-caption text-sm font-medium transition-all duration-200 min-h-[32px] ${
              period === p
                ? 'bg-card text-primary shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {p}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
        {COMPARISONS?.map((c) => (
          <button
            key={c}
            onClick={() => setComparison(c)}
            className={`px-3 py-1.5 rounded-md font-caption text-sm font-medium transition-all duration-200 min-h-[32px] ${
              comparison === c
                ? 'bg-card text-secondary shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}